module.exports = __webpack_public_path__ + "static/ios4-154bb858c48cc13295323d08102471df.svg";